import "core-js"
//import "core-js/es6/map";
//import "core-js/fn/object/assign";
import "mutation-observer"
import "react-app-polyfill/ie9";
import "react-app-polyfill/stable";

import setprototypeof from  'setprototypeof';
Object.setPrototypeOf = setprototypeof;

 

//import areIntlLocalesSupported from 'intl-locales-supported';
//import Intl from 'intl';

//Intl.NumberFormat   = IntlPolyfill.NumberFormat;
//Intl.DateTimeFormat = IntlPolyfill.DateTimeFormat;
//window.Intl = Intl;
// if (window.Intl) {
//     // Determine if the built-in `Intl` has the locale data we need.
//     if (!areIntlLocalesSupported(localesMyAppSupports)) {
//         // `Intl` exists, but it doesn't have the data we need, so load the
//         // polyfill and replace the constructors we need with the polyfill's.
//         require('intl');
//         Intl.NumberFormat   = IntlPolyfill.NumberFormat;
//         Intl.DateTimeFormat = IntlPolyfill.DateTimeFormat;
//     }
// } else {
//     // No `Intl`, so use and load the polyfill.
//     window.Intl = require('intl');
// }